var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "responsive_wrapper", attrs: { id: _vm.updateId } },
    [
      _vm.permissions.includes("REGULATORY_UPDATE_SETTINGS")
        ? _c("div", [
            _vm._m(0),
            _c("div", { staticClass: "mr-tb-15" }, [
              _c("div", { staticClass: "row_wrapper row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-6 col-sm-6 col-xs-12 header_label_text",
                  },
                  [_vm._v("Type")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-3 col-sm-3 hide_xs in_app_label header_label_text",
                  },
                  [_vm._v("Sync Display")]
                ),
                _c("div", { staticClass: "col-md-3 col-sm-3 hide_xs" }, [
                  _c(
                    "span",
                    { staticClass: "ml-15 header_label_text" },
                    [
                      _vm._v(" Email "),
                      _c(
                        "el-popover",
                        {
                          staticClass: "main_popover",
                          attrs: { placement: "bottom-end", trigger: "click" },
                          on: {
                            show: function ($event) {
                              _vm.infoActive = true
                            },
                            hide: function ($event) {
                              _vm.infoActive = false
                            },
                          },
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "mr-bt-10" }, [
                              _c(
                                "span",
                                { staticClass: "tooltip_sub_content_heading" },
                                [_vm._v("Never:")]
                              ),
                              _vm._v(" No emails will be sent "),
                            ]),
                            _c("div", { staticClass: "mr-bt-10" }, [
                              _c(
                                "span",
                                { staticClass: "tooltip_sub_content_heading" },
                                [_vm._v("Every Alert:")]
                              ),
                              _vm._v(
                                " Emails will be sent immediately and for every triggered notification "
                              ),
                            ]),
                            _c("div", { staticClass: "mr-bt-10" }, [
                              _c(
                                "span",
                                { staticClass: "tooltip_sub_content_heading" },
                                [_vm._v("Daily summary:")]
                              ),
                              _vm._v(
                                " A daily summary of the triggered notification type will be sent "
                              ),
                            ]),
                            _c("div", { staticClass: "mr-bt-10" }, [
                              _c(
                                "span",
                                { staticClass: "tooltip_sub_content_heading" },
                                [_vm._v("Weekly summary:")]
                              ),
                              _vm._v(
                                " A weekly summary of the triggered notification type will be sent "
                              ),
                            ]),
                          ]),
                          !_vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon.svg",
                                  alt: "info-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon_active.svg",
                                  alt: "infoactive-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row_wrapper row" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "toggle_switch col-md-3 col-sm-3 col-xs-6" },
                  [
                    _c("small", { staticClass: "display_xs" }, [
                      _vm._v("Sync Display"),
                    ]),
                    _vm.permissions.includes(
                      "REG_WTCH_RUPD_SETT_EDIT_SYNC_DISPLAY"
                    )
                      ? _c("div", [
                          _c("label", { staticClass: "switch" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.regulatory_sync_display,
                                  expression: "regulatory_sync_display",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.regulatory_sync_display
                                )
                                  ? _vm._i(_vm.regulatory_sync_display, null) >
                                    -1
                                  : _vm.regulatory_sync_display,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.regulatory_sync_display,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.regulatory_sync_display =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.regulatory_sync_display = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.regulatory_sync_display = $$c
                                    }
                                  },
                                  function ($event) {
                                    return _vm.$emit(
                                      "update:sync_display",
                                      $event.target.checked
                                    )
                                  },
                                ],
                              },
                            }),
                            _c("span", { staticClass: "slider round" }),
                          ]),
                          _vm.regulatory_sync_display
                            ? _c("span", { staticClass: "switch_label" }, [
                                _vm._v("On"),
                              ])
                            : _c(
                                "span",
                                { staticClass: "switch_label switch_off" },
                                [_vm._v("Off")]
                              ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                  [
                    _c("small", { staticClass: "display_xs ml-20" }, [
                      _vm._v("Email"),
                    ]),
                    _vm.permissions.includes("REG_WTCH_RUPD_SETT_EDIT_EMAIL")
                      ? _c("multiselect", {
                          staticClass: "multiselect-single-dropdown",
                          attrs: {
                            showLabels: false,
                            "close-on-select": true,
                            "allow-empty": false,
                            "open-direction": "bottom",
                            searchable: false,
                            options: _vm.frequency_options.map(
                              (frequency) => frequency.value
                            ),
                            "custom-label": (option) =>
                              _vm.frequency_options.find(
                                (x) => x.value === option
                              ).label,
                            placeholder: "Select",
                          },
                          model: {
                            value: _vm.emailFrequency,
                            callback: function ($$v) {
                              _vm.emailFrequency = $$v
                            },
                            expression: "emailFrequency",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-12 pl-0 pr-0" }, [
              _c(
                "div",
                { staticClass: "col-sm-7 col-xs-12 pl-0 mr-tb-15 alert_text" },
                [_vm._v(" Show regulatory change updates for: ")]
              ),
              _c(
                "div",
                { staticClass: "col-sm-5 col-xs-12 search-country" },
                [
                  _c("search-box", {
                    on: { getList: _vm.searchCountries },
                    model: {
                      value: _vm.searchRegWatch,
                      callback: function ($$v) {
                        _vm.searchRegWatch = $$v
                      },
                      expression: "searchRegWatch",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm.permissions.includes(
              "REG_WTCH_RUPD_SETT_SHOW_REGULATORY_UPDATES"
            )
              ? _c("div", { staticClass: "col-sm-12 container1" }, [
                  _c("div", { staticClass: "section" }, [
                    _c(
                      "div",
                      { staticClass: "scrollable-content content" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "desc_text",
                            staticStyle: { display: "none" },
                          },
                          [
                            _c("span", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectAll,
                                      expression: "selectAll",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    disabled: _vm.disableAllCheckbox,
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.selectAll)
                                      ? _vm._i(_vm.selectAll, null) > -1
                                      : _vm.selectAll,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectAll,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectAll = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectAll = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectAll = $$c
                                      }
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "cr" }),
                              ]),
                            ]),
                            _c(
                              "span",
                              { staticClass: "cust_label all_market_label" },
                              [_vm._v("All Market Regions")]
                            ),
                          ]
                        ),
                        _vm._l(_vm.regions, function (region, index) {
                          return [
                            index !== "Global (non-market specific)"
                              ? _c(
                                  "div",
                                  { key: index, staticClass: "desc_text" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "country_label_container",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "checkbox mr-12",
                                            staticStyle: {
                                              visibility: "hidden",
                                            },
                                          },
                                          [
                                            _c("label", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.regionsMultiselect,
                                                    expression:
                                                      "regionsMultiselect",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled:
                                                    _vm.disableAllCheckbox,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.regionsMultiselect
                                                  )
                                                    ? _vm._i(
                                                        _vm.regionsMultiselect,
                                                        null
                                                      ) > -1
                                                    : _vm.regionsMultiselect,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$a =
                                                          _vm.regionsMultiselect,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.regionsMultiselect =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.regionsMultiselect =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.regionsMultiselect =
                                                          $$c
                                                      }
                                                    },
                                                    function ($event) {
                                                      return _vm.regionEvent(
                                                        index
                                                      )
                                                    },
                                                  ],
                                                },
                                              }),
                                              _c("span", { staticClass: "cr" }),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cursor-pointer flex_grow_1",
                                            class: index.replace(/\s/g, ""),
                                            attrs: {
                                              "data-toggle": "collapse",
                                              "data-target":
                                                "#" +
                                                index.replace(/\s/g, "") +
                                                "_collapse",
                                            },
                                          },
                                          [
                                            index == "Unknown"
                                              ? _c("span", [_vm._v("Others")])
                                              : _c("span", [
                                                  _vm._v(_vm._s(index)),
                                                ]),
                                            _c("span", {
                                              staticClass:
                                                "collapse_arrow fa fa-angle-down",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse ml-30",
                                        attrs: {
                                          id:
                                            index.replace(/\s/g, "") +
                                            "_collapse",
                                        },
                                      },
                                      _vm._l(
                                        region,
                                        function (country, indexcountry) {
                                          return _c(
                                            "div",
                                            {
                                              key: indexcountry,
                                              staticClass: "desc_text",
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "light",
                                                    content:
                                                      "Default country cannot be unselected",
                                                    placement: "top-start",
                                                    disabled:
                                                      _vm.disableAllCheckbox ||
                                                      !country[2],
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.reg_notif_country_ids,
                                                              expression:
                                                                "reg_notif_country_ids",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "checkbox",
                                                            disabled:
                                                              _vm.disableAllCheckbox ||
                                                              country[2],
                                                          },
                                                          domProps: {
                                                            value: country[0],
                                                            checked:
                                                              Array.isArray(
                                                                _vm.reg_notif_country_ids
                                                              )
                                                                ? _vm._i(
                                                                    _vm.reg_notif_country_ids,
                                                                    country[0]
                                                                  ) > -1
                                                                : _vm.reg_notif_country_ids,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.reg_notif_country_ids,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      country[0],
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.reg_notif_country_ids =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.reg_notif_country_ids =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.reg_notif_country_ids =
                                                                    $$c
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.countryEvent(
                                                                  index,
                                                                  country[0]
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "cust_label" },
                                                [_vm._v(_vm._s(country[1]))]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                        _vm._l(
                          _vm.regions["Global (non-market specific)"],
                          function (country, indexs) {
                            return _c(
                              "div",
                              {
                                key: indexs,
                                staticClass: "other-regions pb-8 pt-8",
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "light",
                                      content:
                                        "Default country cannot be unselected",
                                      placement: "top-start",
                                      disabled:
                                        _vm.disableAllCheckbox || !country[2],
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "checkbox inline-checkbox",
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.reg_notif_country_ids,
                                                expression:
                                                  "reg_notif_country_ids",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "checkbox",
                                              disabled:
                                                _vm.disableAllCheckbox ||
                                                country[2],
                                            },
                                            domProps: {
                                              value: country[0],
                                              checked: Array.isArray(
                                                _vm.reg_notif_country_ids
                                              )
                                                ? _vm._i(
                                                    _vm.reg_notif_country_ids,
                                                    country[0]
                                                  ) > -1
                                                : _vm.reg_notif_country_ids,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.reg_notif_country_ids,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = country[0],
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.reg_notif_country_ids =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.reg_notif_country_ids =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.reg_notif_country_ids =
                                                      $$c
                                                  }
                                                },
                                                function ($event) {
                                                  _vm.countryEvent(
                                                    "Global (non-market specific)",
                                                    country[0]
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _c("span", { staticClass: "cr" }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("span", { staticClass: "cust_label" }, [
                                  _vm._v(_vm._s(country[1])),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "col-xs-8 notification_box row" }, [
            _vm._v(
              " You currently do not have permissions to access this section, please contact your Admin. "
            ),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "note_text" }, [
      _c("span", [
        _vm._v(
          'Indicate how often you\'d like to receive regulatory updates and for which countries. To limit the regulatory updates displayed within the application to just the designated countries, select "Sync Display". Otherwise, updates for all countries will be available within the Regulatory Updates page.'
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Regulatory changes occur"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }